import { isAfter, isSameDay } from 'date-fns';
import { ScheduleEntryState } from 'shared/types/habit-schedule';
import { Task } from 'shared/types/task';
import { TaskType } from 'shared/types/task-base';
import { CheckedTaskState } from 'shared/types/task-card-task';
import { Timestamp } from 'shared/types/timestamp';
import { WeekDays } from 'shared/types/week-days';

import { getActiveSchedule } from './get-active-schedule';
import { getScheduleDueDate } from './schedules';

type Options = {
  today: Timestamp;
  showRepeatingAsTodo?: boolean;
  weekStartsOn: WeekDays;
};

export const getTaskCheckedState = (
  { type, completedAt, schedules }: Task,
  { today, showRepeatingAsTodo, weekStartsOn }: Options,
) => {
  if (type === TaskType.Task) {
    return completedAt ? CheckedTaskState.Checked : CheckedTaskState.Unchecked;
  }

  const activeSchedule = getActiveSchedule(schedules);
  if (completedAt || !activeSchedule) {
    return CheckedTaskState.RepeatChecked;
  }

  if (
    activeSchedule.entries.find(
      ({ state, date, value }) =>
        state === ScheduleEntryState.Complete &&
        !!value &&
        isSameDay(today, date),
    )
  ) {
    return showRepeatingAsTodo
      ? CheckedTaskState.Checked
      : CheckedTaskState.RepeatSingleChecked;
  }

  const dueDate = getScheduleDueDate(activeSchedule, { today, weekStartsOn });
  if (dueDate && !isSameDay(dueDate, today) && isAfter(dueDate, today)) {
    return CheckedTaskState.RepeatSingleChecked;
  }

  return CheckedTaskState.Unchecked;
};
